import type { FC } from "react";

import { PromptsComponent } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/prompts-report/prompts-widget/PromptsComponent";

import type { ILLMReport } from "../../shared/types";

export const PromptsReport: FC<ILLMReport> = (reportProps) => {
    return <PromptsComponent {...reportProps} />;
};
